import React, { useContext } from "react";
import useDateFormat from "toolkit/useDateFormat";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";
import CertificationCompletionEndDateTimeLabelField from "./CertificationCompletionEndDateTimeLabelField";

const CertificationCompletionEndDateTimeFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { formatDateTime } = useDateFormat();

  const { completionEndDate } = entity as CertificationInterface;

  return (
    <CertificationCompletionEndDateTimeLabelField
      {...{ completionEndDate, formatDateTime }}
    />
  );
};

export default React.memo(CertificationCompletionEndDateTimeFieldContainer);
